// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imageComponent-container {
  flex: 1 1;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.pfoto-image {
  width: 100%;
  height: 100vh;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/components/LoginForm/ImageComponent.scss"],"names":[],"mappings":"AAAA;EACI,SAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;AACJ;;AAEA;EACI,WAAA;EACA,aAAA;EACA,iBAAA;AACJ","sourcesContent":[".imageComponent-container {\r\n    flex: 1;\r\n    width: 100%;\r\n    height: 100vh;\r\n    overflow: hidden;\r\n}\r\n\r\n.pfoto-image {\r\n    width: 100%;\r\n    height: 100vh;\r\n    object-fit: cover;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
